import React, { useState } from 'react';
import HeaderCat from './HeaderCat';
import Menu from './Menu';
import '../assets/blog.css';
import Contact from './Contact';
import Footer from './Footer';
import Pagination from './Pagination';
import { Link } from 'react-router-dom';

function Blog() {
  const [blogs] = useState([{
    id: 1,
    nom: "Un zoom sur le POD HHC",
    date: "10 MAI 2021",
    desc: "L’arrivée du POD-HHC d’un CBD shop situé dans le 11ème et 13ème arrondissement est l’un des produits phare de l’année 2022...",
    image: "/images/blogs/b1.png",
  },{
    id: 2,
    nom: "Les gummies HHC et CBD",
    date: "10 MAI 2021",
    desc: "L’arrivée du POD-HHC d’un CBD shop situé dans le 11ème et 13ème arrondissement est l’un des produits phare de l’année 2022...",
    image: "/images/blogs/b2.png",
  },{
    id: 3,
    nom: "Le CBD est t’il détect...",
    date: "10 MAI 2021",
    desc: "L’arrivée du POD-HHC d’un CBD shop situé dans le 11ème et 13ème arrondissement est l’un des produits phare de l’année 2022...",
    image: "/images/blogs/b3.png",
  },{
    id: 4,
    nom: "Un zoom sur le POD HHC",
    date: "10 MAI 2021",
    desc: "L’arrivée du POD-HHC d’un CBD shop situé dans le 11ème et 13ème arrondissement est l’un des produits phare de l’année 2022...",
    image: "/images/blogs/b4.png",
  },{
    id: 5,
    nom: "Un zoom sur le POD HHC",
    date: "10 MAI 2021",
    desc: "L’arrivée du POD-HHC d’un CBD shop situé dans le 11ème et 13ème arrondissement est l’un des produits phare de l’année 2022...",
    image: "/images/blogs/b1.png",
    category:"parfum"
  },
  {
    id: 6,
    nom: "Les gummies HHC et CBD",
    date: "10 MAI 2021",
    desc: "L’arrivée du POD-HHC d’un CBD shop situé dans le 11ème et 13ème arrondissement est l’un des produits phare de l’année 2022...",
    image: "/images/blogs/b2.png",
    category:"parfum"
  },{
    id: 7,
    nom: "Le CBD est t’il détect...",
    date: "10 MAI 2021",
    desc: "L’arrivée du POD-HHC d’un CBD shop situé dans le 11ème et 13ème arrondissement est l’un des produits phare de l’année 2022...",
    image: "/images/blogs/b3.png",
    category:"parfum"
  },{
    id: 8,
    nom: "Un zoom sur le POD HHC",
    date: "10 MAI 2021",
    desc: "L’arrivée du POD-HHC d’un CBD shop situé dans le 11ème et 13ème arrondissement est l’un des produits phare de l’année 2022...",
    image: "/images/blogs/b4.png",
  },{
    id: 9,
    nom: "Un zoom sur le POD HHC",
    date: "10 MAI 2021",
    desc: "L’arrivée du POD-HHC d’un CBD shop situé dans le 11ème et 13ème arrondissement est l’un des produits phare de l’année 2022...",
    image: "/images/blogs/b1.png",
  }
  ]);

// pagination

// L'utilisateur est actuellement sur cette page 
const [currentPage, setCurrentPage] = useState(1);
// Nombre d'enregistrements à afficher sur chaque page    
const [recordsPerPage] = useState(10);

// indice du dernier enregistrement
const indexOfLastRecord = currentPage * recordsPerPage;

// indice du premier enregistrement
const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

// sous ensemble du tableau par 10 item
const currentRecords = blogs.slice(indexOfFirstRecord, indexOfLastRecord);
const nPages = Math.ceil(blogs.length / recordsPerPage);

  return (
    <div>
      <Menu />
      {/* Entete */}
      <HeaderCat title={ "BLOG" } subtitle={ 'Toute l’actualité by Shoptacbd'} image={'/images/blog.png'} />
      {/* end entete  */}

      <div className='container blog-group mt-4 blog' id='allBlogs'>
          <div className="blog-header mt-3">
            <h4 className='blog-subtitle'>BLOG</h4>
            <h3 className='blog-title'>NOTRE ACTUALITE</h3>
          </div>
          <div className="blog-body">
            {
              currentRecords.map(blog => <div className="blog-item" key={blog.id}>
                            <img src={window.location.origin +blog.image} alt="" />
                            <h1 className='item-title'><Link className='item-title' to={{pathname:"/"}}>{blog.nom}</Link> </h1>
                            <p className='item-date'>{blog.date} </p>
                            <p className='item-desc text-start'>
                              <span> {blog.note} etoile</span><span> {blog.desc} avis</span>
                              </p>
                        </div>)
            }  
          </div>
      </div>
      {/* pagination */}
        <Pagination
            nPages={nPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}/>
      {/* end pagination */}
      <Contact/>
      <Footer/>
    </div>
  )
}

export default Blog